export class GetClinicMessagesRequest {
  private Action = 'GetClinicMessages';
  public PublicToken: string;

  constructor({ PublicToken }) {
    this.PublicToken = PublicToken;
  }
}
